// extracted by mini-css-extract-plugin
export default {"container":"Inset--container--S4qia","transparent":"Inset--transparent--BYcjM"};